import { render, staticRenderFns } from "./SendMsgModal.vue?vue&type=template&id=18c83210&scoped=true"
import script from "./SendMsgModal.vue?vue&type=script&lang=js"
export * from "./SendMsgModal.vue?vue&type=script&lang=js"
import style0 from "./SendMsgModal.vue?vue&type=style&index=0&id=18c83210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c83210",
  null
  
)

export default component.exports